import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsFilledOrdersEnum } from '@shared/components/trading/widgets/orders-widget/core/enums/stocks/columns-filled-orders.enum'

export const ColumnsOptionsExecutedOrdersConstant: ColumnInterface<ColumnsFilledOrdersEnum>[] = [
	{
		column: ColumnsFilledOrdersEnum.tickerCompany,
		visible: true,
	},
	{
		column: ColumnsFilledOrdersEnum.operation,
		visible: true,
	},
	{
		column: ColumnsFilledOrdersEnum.quantity,
		visible: true,
	},
	{
		column: ColumnsFilledOrdersEnum.sum,
		visible: true,
	},
	{
		column: ColumnsFilledOrdersEnum.profitability,
		visible: true,
	},
	{
		column: ColumnsFilledOrdersEnum.dateTime,
		visible: true,
	},
]
